import Vue from "vue";

export default function (store) {
  Vue.directive("switch", {
    inserted(el, binding) {
      const { arg } = binding;
      if (!store.getters.getSwitch(arg)) {
        el.parentNode && el.parentNode.removeChild(el);
      }
    },
  });
}
